import { Alert, Grid, Typography } from "@mui/material";
import { ShowBase } from "ra-core";
import { FC, useMemo, useState } from "react";
import { Content } from "~/components/content/Content";
import PerformanceAlertsCard from "~/components/performance/PerformanceAlertsCard";
import PerformanceStatusCard from "~/components/performance/PerformanceStatusCard";
import QueryWaitTimeChart from "~/components/performance/QueryWaitTimeChart";
import TimeoutNumChart from "~/components/performance/TimeoutNumChart";
import { TimeRangeType } from "~/gen/api/metrics";
import { OdResourcePageProps } from "~/types/resource";
import { useResourceRegister } from "~/utils/resourceRegister";



const PerformanceTuningDashboard: FC<OdResourcePageProps> = (props) => {
  useResourceRegister({ name: 'dbmetrics-querywaittime' })
  useResourceRegister({ name: 'dbmetrics-timeoutnum' })
  
  const [timeRange, setTimeRange] = useState(TimeRangeType.Week)
  const endTime = useMemo(() => new Date().toISOString(), [])

  return (
    <ShowBase resource="performance-tuning/dashboard" basePath="" id="-1">
      <Content pageName="Performance Dashboard" resourceName="Performance Dashboard" >
        <Grid
          container
          spacing={4}
          sx={{ mt: 2 }}
        >
          <Grid item xs={12}>
            <Alert severity="info">
              <Typography
                variant="body1"
              >
                The Performance Tuning feature is under development and will be available in next release.
              </Typography>
            </Alert>
          </Grid>
          <Grid item xs={12} md={6}>
            <PerformanceStatusCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <PerformanceAlertsCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <QueryWaitTimeChart timeRange={timeRange} setTimeRange={setTimeRange} endTime={endTime} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TimeoutNumChart timeRange={timeRange} setTimeRange={setTimeRange} endTime={endTime} />
          </Grid>
        </Grid>
      </Content>
    </ShowBase>
  )
}

export default PerformanceTuningDashboard;
